import permission from "@/stores/permission.store";

export default {
  path: "/cms",
  component: () => import("@/views/cms/Layout.vue"),
  children: [
    {
      path: "video",
      meta: {
        iconActive: "CMS",
        permission: permission.user.read,
        breadcrumb: [
          {
            name: "Dashboard",
            link: "/",
          },
          {
            name: "CMS Video",
          },
        ],
      },
      component: () => import("@/views/cms/FormVideo.vue"),
    },
  ],
};
